// Toast notification constants
export const TOAST_OPTIONS = {
  style: {
    fontSize: "12px",
    fontWeight: 500,
    borderRadius: "20px",
  },
};
